module.exports = __webpack_public_path__ + "static/media/hide-post-icon.380d4c97.svg";